/** compliance-service routes (TO-232). */
export const ComplianceRoutes = {
	listErasures: '/compliance/erasures',
	createErasure: '/compliance/erasures',
	getErasure: '/compliance/erasures/{id}',
	confirmErasure: '/compliance/erasures/{id}/confirm',
	cancelErasure: '/compliance/erasures/{id}/cancel',
	erasureCertificateLink: '/compliance/erasures/{id}/certificate-link',
	listLegalHolds: '/compliance/legal-holds',
	placeLegalHold: '/compliance/legal-holds',
	releaseLegalHold: '/compliance/legal-holds/{id}/release',
	listSars: '/compliance/sars',
	createSar: '/compliance/sars',
	getSar: '/compliance/sars/{id}',
	sarDownloadLink: '/compliance/sars/{id}/download-link',
}
